import { render, staticRenderFns } from "./DecommissionedDevices.vue?vue&type=template&id=664450ec&scoped=true"
import script from "./DecommissionedDevices.vue?vue&type=script&lang=js"
export * from "./DecommissionedDevices.vue?vue&type=script&lang=js"
import style0 from "./DecommissionedDevices.vue?vue&type=style&index=0&id=664450ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664450ec",
  null
  
)

/* custom blocks */
import block0 from "./DecommissionedDevices.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports